import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ChartModule } from 'angular-highcharts';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import * as moment from 'moment';
import { AssignPerformanceArrowPipe } from './_pipes/assign-performance-arrow.pipe';
import { CorporateActionsIdTransform } from './_pipes/corporate-actions-id-transform.pipe';
import { AbsolutValuePipe } from './_pipes/absolut-value.pipe';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faMobile, faChevronUp, faAngleUp, faAngleDown, faCalendarAlt, faSyncAlt, faChevronDown, faBalanceScale, faWallet, faChartPie, faChevronCircleDown, faMoneyBillWave, faChartBar, faReceipt, faBars } from '@fortawesome/free-solid-svg-icons';
import { NoDataCardComponent } from './_helper/no-data-card/no-data-card.component';
import { PortfolioCompositionComponent } from './assetManagersReport/portfolio-composition/portfolio-composition.component';
import { CurrentPortfolioComponent } from './assetManagersReport/current-portfolio/current-portfolio.component';
import { CashDividendsComponent } from './assetManagersReport/cash-dividends/cash-dividends.component';
import { InterestOverviewComponent } from './assetManagersReport/interest-overview/interest-overview.component';
import { CorporateActionsComponent } from './assetManagersReport/corporate-actions/corporate-actions.component';
import { EquityComponent } from './assetManagersReport/equity/equity.component';

@NgModule({
  declarations: [
    AssignPerformanceArrowPipe,
    CorporateActionsIdTransform,
    AbsolutValuePipe,
    NoDataCardComponent,
    PortfolioCompositionComponent,
    CurrentPortfolioComponent,
    CashDividendsComponent,
    InterestOverviewComponent,
    CorporateActionsComponent,
    EquityComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    FormsModule,
    ChartModule,
    NgxDaterangepickerMd.forRoot({
      format: 'MMMM DD, YYYY',
      applyLabel: "Ok",
      daysOfWeek: moment.weekdaysMin(),
      monthNames: moment.monthsShort()
    }),
    FontAwesomeModule
  ],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    FormsModule,
    ChartModule,
    CorporateActionsIdTransform,
    AssignPerformanceArrowPipe,
    AbsolutValuePipe,
    NgxDaterangepickerMd,
    FontAwesomeModule,
    NoDataCardComponent,
    PortfolioCompositionComponent,
    CurrentPortfolioComponent,
    CashDividendsComponent,
    InterestOverviewComponent,
    CorporateActionsComponent,
    EquityComponent
  ]
})

export class SharedModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faMobile, faChevronUp, faChevronDown, faAngleUp, faAngleDown, faCalendarAlt, faSyncAlt, faBalanceScale, faWallet, faChartPie, faChevronCircleDown, faMoneyBillWave, faChartBar, faReceipt, faBars);
  }
}
